import React, { useEffect, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import axios from '../config/api';
import { API_URL } from '../config/api';

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH

function GoogleAuthCallback() {
  const navigate = useNavigate();
  const { checkAuth } = useAuth();
  const hasProcessed = useRef(false);
  const [searchParams] = useSearchParams();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processGoogleAuth = async () => {
      const code = searchParams.get('code');

      if (!code) {
        navigate('/login', { replace: true, state: { error: 'Google sign-in failed. No authorization code received.' } });
        return;
      }

      try {
        // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
        const redirectUri = window.location.origin + '/auth/google';
        const response = await axios.post(`${API_URL}/api/auth/google-session`, {
          code: code,
          redirect_uri: redirectUri
        });

        const { access_token, needs_profile_setup } = response.data;
        localStorage.setItem('token', access_token);

        if (needs_profile_setup) {
          await checkAuth();
          navigate('/complete-profile', { replace: true });
        } else {
          await checkAuth();
          navigate('/home', { replace: true });
        }
      } catch (error) {
        console.error('Google auth failed:', error);
        const detail = error.response?.data?.detail || 'Google sign-in failed. Please try again.';
        navigate('/login', { replace: true, state: { error: detail } });
      }
    };

    processGoogleAuth();
  }, [navigate, checkAuth, searchParams]);

  return (
    <div className="min-h-screen bg-gradient-civote flex items-center justify-center" data-testid="google-auth-callback">
      <div className="bg-white rounded-card shadow-card p-8 text-center">
        <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-primary mx-auto mb-4"></div>
        <p className="text-gray-600 font-rubik">Signing you in with Google...</p>
      </div>
    </div>
  );
}

export default GoogleAuthCallback;
